import { ComponentProps, useEffect } from "react";
import { Button } from "../../Atoms/Button";
import { Input } from "../../Atoms/Inputs/Input";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import * as S from "./styles";
import { useGoalsFormTemplate } from "./useGoalsFormTemplate";
import { ISelectOptions } from "../../../types/inputs";
import { IMetaDTO, IMetaForm } from "../../../types/meta";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";

interface IGoalsFormTemplateProps extends ComponentProps<"form"> {
  data?: IMetaDTO;
  handleSubmit: (data: IMetaForm) => void;
}

export const GoalsFormTemplate = ({
  data,
  handleSubmit,
  ...rest
}: IGoalsFormTemplateProps) => {
  const {
    navigate,
    ANOS_OPTIONS,
    MESES_OPTIONS,
    lojasOptions,
    control,
    handleSubmitWith,
    errors,
    isSubmitting,
    setValue,
  } = useGoalsFormTemplate();

  useEffect(() => {
    if (!data) return;

    const parsed = dayjs(data.mes);

    if (parsed.isValid()) {
      const ano = parsed.year();
      const mes = parsed.month() + 1;
      setValue("ano", ano);
      setValue("mes", mes);
    }

    setValue("uuidMunicipio", data?.municipio?.uuid);
    setValue("quantidadeTotal", data?.quantidadeTotal);
  }, [data]);

  return (
    <S.Form {...rest} onSubmit={handleSubmitWith(handleSubmit)}>
      <S.FormWrapperContent>
        <div>
          <Controller
            control={control}
            name="mes"
            render={({ field }) => (
              <SimpleSelect
                required
                options={MESES_OPTIONS}
                label="Mês"
                value={
                  MESES_OPTIONS.find((o) => o.value === field.value) || null
                }
                onChange={(opt: ISelectOptions) => field.onChange(opt.value)}
              />
            )}
          />
          {errors.mes && (
            <div style={{ color: "#d32f2f", fontSize: 12 }}>
              {String(errors.mes.message)}
            </div>
          )}
        </div>

        <div>
          <Controller
            control={control}
            name="ano"
            render={({ field }) => (
              <SimpleSelect
                options={ANOS_OPTIONS}
                label="Ano"
                required
                value={
                  ANOS_OPTIONS.find((o) => o.value === field.value) || null
                }
                onChange={(opt: ISelectOptions) => field.onChange(opt.value)}
              />
            )}
          />
          {errors.ano && (
            <div style={{ color: "#d32f2f", fontSize: 12 }}>
              {String(errors.ano.message)}
            </div>
          )}
        </div>

        <div>
          <Controller
            control={control}
            name="uuidMunicipio"
            render={({ field }) => (
              <SimpleSelect
                options={lojasOptions}
                label="Unidade"
                required
                value={
                  lojasOptions.find((o) => o.value === field.value) || null
                }
                onChange={(opt: ISelectOptions) => field.onChange(opt.value)}
              />
            )}
          />
          {errors.uuidMunicipio && (
            <div style={{ color: "#d32f2f", fontSize: 12 }}>
              {String(errors.uuidMunicipio.message)}
            </div>
          )}
        </div>

        <div>
          <Controller
            control={control}
            name="quantidadeTotal"
            render={({ field }) => (
              <Input
                required
                label="Quantidade de Vistorias"
                type="number"
                value={field.value ?? ""}
                onChange={(e) => field.onChange(Number(e.currentTarget.value))}
              />
            )}
          />
          {errors.quantidadeTotal && (
            <div style={{ color: "#d32f2f", fontSize: 12 }}>
              {String(errors.quantidadeTotal.message)}
            </div>
          )}
        </div>
      </S.FormWrapperContent>
      <S.FormWrapperButtons>
        <div>
          <Button
            data-variant-underline
            type="button"
            onClick={() => {
              navigate(-1);
            }}
          >
            Voltar
          </Button>
        </div>
        <div>
          <Button disabled={isSubmitting}>Salvar</Button>
        </div>
      </S.FormWrapperButtons>
    </S.Form>
  );
};
